import standardAction from '../../../utilities/standard-action';
import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function hideReturnFormDialog(): RootActionTypes {
  return standardAction(ActionTypes.HIDE_RETURN_FORM_DIALOG);
}
